<template>
    <div class="popup-wrapper popup-wrapper-sts">
        <div class="popup-wrapper--container">
            <div class="popup popup-medium">
                <div class="popup--close" @click="$emit('closeCompletionPopup')">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 5.0625L10 10.0625L5 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 5.0625L10 10.0625L15 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div class="popup--header">
                    <div>{{ cart.delivery_address.firstname }}, podporíte denník Postoj a zaokrúhlite sumu?</div>

                    <p class="p-medium">
                        Váš príspevok premeníme na kvalitné články a nové, zaujímavé knižné tituly. <br>
                        Ďakujeme.
                    </p>
                </div>

                <div class="popup--body">
                    <div class="rounding-container">
                        <div class="rounding-container--header">
                            Aktuálna suma celkom: <strong>{{ cart.final_price_formatted }} <small>€</small></strong>
                        </div>

                        <div class="rounding-container--body">
                            <div class="rounding-container--body--title">
                                Zaokrúhliť na:
                            </div>

                            <div class="rounding-container--body--options">
                                <div class="rounding-container--body--options--box" v-for="(round, index) in cart.rounding" :key="index" @click="setCartPriceRounding( round.value )">
                                    <div class="round-value" :class="{'round-value-active' : cart.price_rounding == round.value}">{{ round.result }} <small>€</small></div>
                                </div>

                                <div class="rounding-container--body--options--box">
                                    <input class="round-value" :class="{'round-value-active' : cart.price_rounding && cart.price_rounding == (roundAmount - cart.final_price).toFixed(2)}" type="number" step="1" placeholder="iná suma" v-model="roundAmount" @focus="$emit('setCartPriceRounding', null)" @input="roundToAnotherAmount()">
                                </div>
                            </div>
                        </div>

                        <div v-if="errors && errors.amount" class="rounding-container--footer">
                            <div class="form-error form-error-center">{{ errors.amount[0] }}</div>
                        </div>

                        <div v-if="errors && errors.price_rounding" class="rounding-container--footer">
                            <div class="form-error form-error-center">{{ errors.price_rounding[0] }}</div>
                        </div>
                    </div>
                </div>

                <div class="popup--footer footer-center">
                    <span v-if="!isSubmitting || !clickedRoundButton"
                          class="btn btn-default btn-padding-medium btn-width-200"
                          @click="createOrder(false)"
                          :class="{'disabled': isSubmitting}"
                          :disabled="isSubmitting">
                        {{ isSubmitting && !clickedRoundButton ? 'Počkajte prosím' : 'Bez zaokrúhlenia' }}
                    </span>
                    <span v-if="!isSubmitting || clickedRoundButton"
                          class="btn btn-action-red btn-padding-medium btn-width-200"
                          @click="createOrder(true)"
                          :class="{'disabled': isSubmitting}"
                          :disabled="isSubmitting">
                        {{ isSubmitting && clickedRoundButton ? 'Počkajte prosím' : 'Zaokrúhliť' }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        emits: ['close-completion-popup', 'set-cart-price-rounding'],
        props: {
            onCloseCompletionPopup: {
                type: Function
            },
            onSetCartPriceRounding: {
                type: Function
            },
            cart: {
                type: Object
            }
        },
        data() {
            return {
                errors: null,
                roundAmount: null,
                isSubmitting: false,
                clickedRoundButton: false
            }
        },
        methods: {
            createOrder(round) {
                this.isSubmitting = true
                this.clickedRoundButton = round

                let cart = this.cart
                cart.round = round

                axios.post('/api/shop/cart/order/store', cart)
                .then( response => {
                    window.location.href = response.data.redirect
                })
                .catch( errors => {
                    this.errors = errors.response.data.errors
                    this.isSubmitting = false
                })
            },
            roundToAnotherAmount() {
                setTimeout(() => {

                    axios.post('/api/shop/cart/payment/round-to-custom-amount', {
                        cart: this.cart,
                        amount: this.roundAmount
                    }).then( response => {

                        this.errors = null
                        this.$emit('setCartPriceRounding', response.data)

                    }).catch( errors => { this.errors = errors.response.data.errors })

                }, 750)
            },
            setCartPriceRounding( value ) {
                this.roundAmount = null

                this.cart.price_rounding == value
                    ? this.$emit('setCartPriceRounding', null)
                    : this.$emit('setCartPriceRounding', value)
            }
        }
    }
</script>
